import React, { useState, useEffect } from "react";
import "./AssistanceForm.css";
import { useNavigate } from "react-router-dom";
import Footer from '../admin/Footer.js';
import Header from "../admin/Header.js";
import { API, FormAPI } from './api.js';

const AssistanceForm = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    surname: "", firstname: "", fathername: "", patta: "", janmadin: "",
    mobile: "", email: "", aadhar: "",

    class10: "", class12: "", ugDegree: "", ugGrade: "",mscit: "",

    jati: "", jatiPraman: "", jatiCertNumber: "", jatiCertDate: "", jatiCertIssuer: "",
    arakshan: "", arakshanCertNumber: "", arakshanCertDate: "", arakshanCertIssuer: "",
    ews: "", ewsDate: "", ewsVillage: "", ewsValidityYear: "",
    sebc: "", sebcDate: "", sebcVillage: "", sebcValidityYear: ""
  });

  const [errors, setErrors] = useState({});
  const [confirmChecks, setConfirmChecks] = useState({
    fullName: false,
    dob: false,
    aadhar: false,
    caste: false,
    finalConfirm:false,
  });

  useEffect(() => {
    const savedData = sessionStorage.getItem("clerkFormData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("clerkFormData", JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    const selectedPost = sessionStorage.getItem("selectedPost");
    console.log("Selected Post:", selectedPost);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    
    if (name === "jatiPraman" && value === "false") {
      setFormData((prevData) => ({
        ...prevData,
        jatiCertNumber: null,
        jatiCertDate: null,
        jatiCertIssuer: null,
      }));
    }
  
    // Reset fields for जात वैधता प्रमाण when "नाही" is selected
    if (name === "arakshan" && value === "false") {
      setFormData((prevData) => ({
        ...prevData,
        arakshanCertNumber: null,
        arakshanCertDate: null,
        arakshanCertIssuer: null,
      }));
    }
  
    // Reset fields for EWS when "नाही" is selected
    if (name === "ews" && value === "false") {
      setFormData((prevData) => ({
        ...prevData,
        ewsDate: null,
        ewsVillage: null,
        ewsValidityYear: null,
      }));
    }
  
    // Reset fields for SEBC when "नाही" is selected
    if (name === "sebc" && value === "false") {
      setFormData((prevData) => ({
        ...prevData,
        sebcDate: null,
        sebcVillage: null,
        sebcValidityYear: null,
      }));
    }
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const handleConfirmChange = (e) => {
    const { name, checked } = e.target;
    setConfirmChecks({ ...confirmChecks, [name]: checked });
  };
  
  const validateStep = () => {
    const stepErrors = {};
    if (step === 1) {
      const fields = ["surname", "firstname", "fathername", "patta", "janmadin", "mobile", "email", "aadhar"];
      fields.forEach(field => {
        if (!formData[field]?.trim()) stepErrors[field] = "हे फील्ड आवश्यक आहे";
      });
      if (!/^\d{10}$/.test(formData.mobile)) stepErrors.mobile = "१० अंकी मोबाईल नंबर टाका";
      if (!/^\S+@\S+\.\S+$/.test(formData.email)) stepErrors.email = "योग्य ईमेल टाका";
      if (!/^\d{12}$/.test(formData.aadhar)) stepErrors.aadhar = "१२ अंकी आधार क्रमांक टाका";
    }

    if (step === 2) {
      const fields = ["class10", "class12", "ugDegree", "ugGrade","mscit"];
      fields.forEach(field => {
        if (!formData[field]?.trim()) stepErrors[field] = "हे फील्ड आवश्यक आहे";
      });
    }

    if (step === 3) {
      if (!formData.jati) stepErrors.jati = "जात निवडा";
    }

    if (step === 4) {
      Object.entries(confirmChecks).forEach(([key, value]) => {
        if (!value) stepErrors[key] = "कृपया ही खात्री करा";
      });
    }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateStep()) return;
  
    const payload = {
      email: formData.email,
      aadhar_no: formData.aadhar,
      mobile: formData.mobile,
      flag: 2,
    };
  
    try {
      const response = await fetch(FormAPI.checkDuplicateFields(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
  
      let errorMessage = '';
  
      // Check for specific messages from the API
      if (result.message === 'Email already exists') {
        errorMessage += 'या ईमेल आयडीने फॉर्म आधीच भरला गेला आहे.\n';
      }
      if (result.message === 'Aadhar number already exists') {
        errorMessage += 'या आधार क्रमांकाने फॉर्म आधीच भरला गेला आहे.\n';
      }
      if (result.message === 'Mobile number already exists') {
        errorMessage += 'या मोबाइल क्रमांकाने फॉर्म आधीच भरला गेला आहे.\n';
      }
  
      // If any error message exists, display it
      if (errorMessage) {
        alert(errorMessage); // You can replace this with a custom error display
      } else {
        setStep(prev => prev + 1); // Proceed to the next step if no error
      }
  
    } catch (error) {
      console.error('API error:', error);
      alert('सर्व्हर त्रुटी. कृपया नंतर पुन्हा प्रयत्न करा.');
    }
  };
  
  
  const handleBack = () => {
    setStep(prev => prev - 1);
  };

  const mapFormDataToPayload = (formData, flagValue) => {
    const formatDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date)) return null;
      return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
    };
  
    return {
      flag: parseInt(flagValue),
      last_name: formData.surname,
      name: formData.firstname,
      father_name: formData.fathername,
      address: formData.patta,
      date_of_birth: formatDate(formData.janmadin),
      mobile: formData.mobile,
      email: formData.email,
      aadhar_no: formData.aadhar,
      tenth_per: parseInt(formData.class10),
      twelth_per: parseInt(formData.class12),
      choose_degree: formData.ugDegree,
      obtained_grade: formData.ugGrade,
      //typewriting_marathi_score: parseInt(formData.tkMarathi),
      //typewriting_english_score: parseInt(formData.tkEnglish),
      mscit_per: parseInt(formData.mscit),
      cast: formData.jati,
      cast_certificate: formData.jatiPraman === "true" ? true : false,
      cast_cert_no: formData.jatiCertNumber || null,
      date_cast_cert: formatDate(formData.jatiCertDate),
      cast_cert_issuing_village: formData.jatiCertIssuer || null,
      cast_validity_certificate: formData.arakshan=== "true" ? true : false,
      cast_validity_cert_no: formData.arakshanCertNumber || null,
      date_cast_validity_cert: formatDate(formData.arakshanCertDate),
      cast_validity_cert_issuing_village: formData.arakshanCertIssuer || null,
      ews: formData.ews=== "true" ? true : false,
      ews_cert_date: formatDate(formData.ewsDate),
      ews_cert_village: formData.ewsVillage || null,
      ews_cert_validity_year: formData.ewsValidityYear || null,
      sebc_cert: formData.sebc=== "true" ? true : false,
      sebc_cert_date: formatDate(formData.sebcDate),
      sebc_cert_village: formData.sebcVillage || null,
      non_creamy_validity_year: formData.sebcValidityYear || null,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (validateStep()) {
      setIsSubmitting(true); // Disable the button during submission
  
      const flagValue = sessionStorage.getItem("selectedPost");
      const payload = mapFormDataToPayload(formData, flagValue);
  
      fetch(API.submitUserData, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Something went wrong while submitting");
          }
          return res.json();
        })
        .then((data) => {
          const message = data.message || "";
  
          if (message.includes("Form submission is closed")) {
            alert("अर्ज भरण्याची अंतिम तारीख संपली आहे. धन्यवाद !");
            navigate("/"); 
            return;
          } else if (message === "Email already used for this post.") {
            alert("या ईमेल आयडीने फॉर्म आधीच भरला गेला आहे.");
          } else if (message === "Aadhar number already used for this post.") {
            alert("या आधार क्रमांकाने फॉर्म आधीच भरला गेला आहे.");
          } else if (message === "Mobile number already used for this post.") {
            alert("या मोबाइल क्रमांकाने फॉर्म आधीच भरला गेला आहे.");
          } else {
            alert("फॉर्म यशस्वीरित्या सबमिट झाला!");
            navigate("/last");
            setFormData({
              surname: "", firstname: "", fathername: "", patta: "", janmadin: "",
              mobile: "", email: "", aadhar: "",
  
              class10: "", class12: "", ugDegree: "", ugGrade: "", mscit: "",
  
              jati: "", jatiPraman: "", jatiCertNumber: "", jatiCertDate: "", jatiCertIssuer: "",
              arakshan: "", arakshanCertNumber: "", arakshanCertDate: "", arakshanCertIssuer: "",
              ews: "", ewsDate: "", ewsVillage: "", ewsValidityYear: "",
              sebc: "", sebcDate: "", sebcVillage: "", sebcValidityYear: ""
            });
          }
        })
        .catch((err) => {
          console.error("Error submitting form:", err);
          alert("फॉर्म सबमिट करण्यात अडचण आली.");
        })
        .finally(() => {
          setIsSubmitting(false); // Re-enable button
        });
    }
  };
  
  return (
    <>
    <Header/>
    <div className="container-new">
    <form className="marathi-form1" onSubmit={handleSubmit}>
      <h2>प्रयोगशाळा सहाय्यक पदासाठी अर्ज</h2>

        <div className="progress-bar-container1">
        <div className={`progress-step ${step >= 1 ? "active" : ""}`} data-step="1" data-icon=""> वैयक्तिक माहिती</div>
        <div className={`progress-step ${step >= 2 ? "active" : ""}`} data-step="2" data-icon=""> शैक्षणिक माहिती</div>
        <div className={`progress-step ${step >= 3 ? "active" : ""}`} data-step="3" data-icon=""> जात व आरक्षण संबंधित माहिती</div>
        <div className={`progress-step ${step === 4 ? "active" : ""}`} data-step="4" data-icon=""> सबमिट</div>
        </div>
        
        <p className="para">फॉर्म मराठी भाषेत भरावा.</p>
      {step === 1 && (
        <div className="form-section1">
        <h3>वैयक्तिक माहिती</h3>
        
        <label>नाव (आडनाव, नाव, वडिलांचे नाव)</label>
        <div className="name-row1">
        <input name="surname" placeholder="आडनाव" onChange={handleChange} value={formData.surname}/>
        {errors.surname && <span className="error">{errors.surname}</span>}

        <input name="firstname" placeholder="नाव" onChange={handleChange} value={formData.firstname}/>
        {errors.firstname && <span className="error">{errors.firstname}</span>}

        <input name="fathername" placeholder="वडिलांचे नाव" onChange={handleChange} value={formData.fathername} />
        {errors.fathername && <span className="error">{errors.fathername}</span>}
        </div>

        <label>पत्रव्यवहाराचा पूर्ण पत्ता </label>
        <input name="patta" onChange={handleChange} value={formData.patta}/>
        {errors.patta && <span className="error">{errors.patta}</span>}

        <label>जन्मतारीख (आकडे इंग्रजीमध्ये भरणे)</label>
        {/*<input
        name="janmadin"
        type="date"
        value={formData.janmadin}
        onChange={handleChange}
        />*/}
        <input
          name="janmadin"
          type="date"
          value={formData.janmadin}
          onChange={(e) => {
            const selectedDate = new Date(e.target.value);
            const today = new Date();

            const age = today.getFullYear() - selectedDate.getFullYear();
            const monthDiff = today.getMonth() - selectedDate.getMonth();
            const dayDiff = today.getDate() - selectedDate.getDate();

            const realAge =
              monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0) ? age : age - 1;

            if (realAge >= 18 || e.target.value === "") {
              handleChange(e);
            } else {
              alert("वय 18 वर्षांपेक्षा जास्त असावे."); 
            }
          }}
        />
        {errors.janmadin && <span className="error">{errors.janmadin}</span>}

        <label>मोबाईल नंबर (आकडे इंग्रजीमध्ये भरणे)</label>
       {/* <input name="mobile" onChange={handleChange} value={formData.mobile} maxLength={10}/>*/}
       <input
        type="text"
        name="mobile"
        value={formData.mobile}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,10}$/.test(value)) {
            handleChange(e);
          }
        }}
        inputMode="numeric"
      />
        {errors.mobile && <span className="error">{errors.mobile}</span>}

        <label>ईमेल आयडी</label>
        <input name="email" type="email" onChange={handleChange} value={formData.email} />
        {errors.email && <span className="error">{errors.email}</span>}

        <label>आधार क्रमांक (आकडे इंग्रजीमध्ये भरणे, सलग आकडे टाईप करणे)</label>
         {/* <input name="aadhar" onChange={handleChange} value={formData.aadhar} maxLength={12}/>*/}
         <input
        type="text"
        name="aadhar"
        value={formData.aadhar}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,12}$/.test(value)) {
            handleChange(e);
          }
        }}
        inputMode="numeric"
      />
        {errors.aadhar && <span className="error">{errors.aadhar}</span>}
        </div>
      )}

      {step === 2 && (
        <div className="form-section1">
        <h3>शैक्षणिक माहिती</h3>

            <label>इयत्ता १० वी प्राप्त टक्केवारी</label>
             {/* <input name="class10" onChange={handleChange} value={formData.class10} type="number" maxLength={3}/>*/}
             <input
              name="class10"
              type="text"
              value={formData.class10}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}$/.test(value)) {
                  const numericValue = parseInt(value, 10);

                  if (value === "" || (numericValue >= 1 && numericValue <= 100)) {
                    handleChange(e);
                  }
                }
              }}
              inputMode="numeric"
            />
            {errors.class10 && <span className="error">{errors.class10}</span>}

            <label>इयत्ता १२ वी प्राप्त टक्केवारी</label>
             {/* <input name="class12" onChange={handleChange} value={formData.class12} type="number" maxLength={3}/>*/}
             <input
              name="class12"
              type="text"
              value={formData.class12}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}$/.test(value)) {
                  const numericValue = parseInt(value, 10);

                  if (value === "" || (numericValue >= 1 && numericValue <= 100)) {
                    handleChange(e);
                  }
                }
              }}
              inputMode="numeric"
            />
            {errors.class12 && <span className="error">{errors.class12}</span>}

            <label>पदवी निवडा</label>
            <select name="ugDegree" value={formData.ugDegree} onChange={handleChange}>
            <option value="">--पदवी निवडा--</option>
            <option value="बी.ए">बी.ए</option>
            <option value="बी.एस.सी">बी.एस.सी</option>
            <option value="बी.कॉम">बी.कॉम</option>
            </select>
            {errors.ugDegree && <span className="error">{errors.ugDegree}</span>}

            {formData.ugDegree && (
            <div className="fade-slide1">
                <label> प्राप्त श्रेणी</label>
                <select name="ugGrade" value={formData.ugGrade} onChange={handleChange}>
            <option value="">--श्रेणी निवडा--</option>
            <option value="प्रथम">प्रथम </option>
            <option value="द्वितीय">द्वितीय</option>
            <option value="पास क्लास">पास क्लास</option>
            </select>
                {errors.ugGrade && <span className="error">{errors.ugGrade}</span>}
            </div>
            )}

            <label>एम.एस.सी.आय.टी परीक्षेत प्राप्त टक्केवारी</label>
             {/* <input name="mscit" onChange={handleChange} value={formData.mscit} type="number" maxLength={3}/>*/}
             <input
              name="mscit"
              type="text"
              value={formData.mscit}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}$/.test(value)) {
                  const numericValue = parseInt(value, 10);

                  if (value === "" || (numericValue >= 1 && numericValue <= 100)) {
                    handleChange(e);
                  }
                }
              }}
              inputMode="numeric"
            />
            {errors.mscit && <span className="error">{errors.mscit}</span>}
        </div>
      )}

      {step === 3 && (
        <div className="form-section1">
          <h3>जात व आरक्षण संबंधित माहिती</h3>
          <label>जात प्रवर्ग</label>
          <select name="jati" value={formData.jati} onChange={handleChange}>
            <option value="">-- निवडा --</option>
            <option value="अनुसूचित जाती (SC)">अनुसूचित जाती (SC)</option>
            <option value="अनुसूचित जमाती (ST)">अनुसूचित जमाती (ST)</option>
            <option value="विमुक्त जाती अ (NT- A)">विमुक्त जाती अ (NT- A)</option>
            <option value="भटक्या जमाती ब (NT-B)">भटक्या जमाती ब (NT-B)</option>
            <option value="भटक्या जमाती क (NT-C)">भटक्या जमाती क (NT-C)</option>
            <option value="भटक्या जमाती ड (NT-D)">भटक्या जमाती ड (NT-D)</option>
            <option value="विशेष मागास प्रवर्ग (SBC)">विशेष मागास प्रवर्ग (SBC)</option>           
            <option value="इतर मागास वर्ग (OBC)">इतर मागास वर्ग (OBC)</option>
            <option value="सामाजिक आणि शैक्षणिक मागास प्रवर्ग ( SEBC)">सामाजिक आणि शैक्षणिक मागास प्रवर्ग ( SEBC))</option>
            <option value="आर्थिक दुर्बल घटक ( EWS)">आर्थिक दुर्बल घटक ( EWS)</option>
            <option value="खुला (Open)">खुला (Open)</option>
          </select>
          {errors.jati && <span className="error">{errors.jati}</span>}

          {["अनुसूचित जाती (SC)", "अनुसूचित जमाती (ST)","विमुक्त जाती अ (NT- A)", "भटक्या जमाती ब (NT-B)","भटक्या जमाती क (NT-C)","भटक्या जमाती ड (NT-D)","इतर मागास वर्ग (OBC)","विशेष मागास प्रवर्ग (SBC)"].includes(formData.jati) && (<>  <label>जात प्रमाणपत्र आहे का?</label>
        <select name="jatiPraman" onChange={handleChange} value={formData.jatiPraman}>
        <option value="false">नाही</option>
        <option value="true">होय</option>
        </select>

        {formData.jatiPraman === "true" && (
        <div className="fade-slide1">
            <label>जात प्रमाणपत्र क्रमांक</label>
            <input name="jatiCertNumber" onChange={handleChange} value={formData.jatiCertNumber}/>

            <label>जात प्रमाणपत्र दिनांक</label>
            <input
            name="jatiCertDate"
            type="date"
            value={formData.jatiCertDate}
            onChange={handleChange}
            />

            <label>जात प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव</label>
            <input name="jatiCertIssuer" onChange={handleChange} value={formData.jatiCertIssuer} />
        </div>
        )}

        <label>जात वैधता प्रमाणपत्र आहे का?</label>
        <select name="arakshan" onChange={handleChange} value={formData.arakshan}>
        <option value="false">नाही</option>
        <option value="true">होय</option>
        </select>

        {formData.arakshan === "true" && (
        <div className="fade-slide1">
            <label>जात वैधता प्रमाणपत्र क्रमांक</label>
            <input name="arakshanCertNumber" onChange={handleChange} value={formData.arakshanCertNumber} />

            <label>जात वैधता प्रमाणपत्र दिनांक</label>
            <input
            name="arakshanCertDate"
            type="date"
            value={formData.arakshanCertDate}
            onChange={handleChange}
            />

            <label>जात वैधता प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव</label>
            <input name="arakshanCertIssuer" onChange={handleChange} value={formData.arakshanCertIssuer}/>
        </div>
        )}</>)}

        {["आर्थिक दुर्बल घटक ( EWS)"].includes(formData.jati) && (<><label>इ.डब्ल्यू.एस प्रमाणपत्र आहे का?</label>
        <select name="ews" onChange={handleChange} value={formData.ews}>
        <option value="false">नाही</option>
        <option value="true">होय</option>
        </select>

        {formData.ews === "true" && (
          <div className="fade-slide1">
        <label>इ.डब्ल्यू.एस प्रमाणपत्र दिनांक</label>
        <input
        name="ewsDate"
        type="date"
        value={formData.ewsDate}
        onChange={handleChange}
        />

        <label>इ.डब्ल्यू.एस प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव</label>
        <input name="ewsVillage" onChange={handleChange} value={formData.ewsVillage} />

        <label>इ.डब्ल्यू.एस प्रमाणपत्र वैधता वर्ष</label>
        {/*<input name="ewsValidityYear" onChange={handleChange} value={formData.ewsValidityYear} />*/}
        <input
        type="text"
        name="ewsValidityYear"
        value={formData.ewsValidityYear}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,4}$/.test(value)) {
            handleChange(e);
          }
        }}
        inputMode="numeric"
      />
        </div>
        )}</>)}

        {formData.jati === "सामाजिक आणि शैक्षणिक मागास प्रवर्ग ( SEBC)" && (<>   <label>एस.ई.बी.सी प्रमाणपत्र आहे का?</label>
        <select name="sebc" onChange={handleChange} value={formData.sebc}>
        <option value="false">नाही</option>
        <option value="true">होय</option>
        </select>

        {formData.sebc === "true" && (
          <div className="fade-slide1">
        <label>एस.ई.बी.सी प्रमाणपत्र दिनांक</label>
        <input
        name="sebcDate"
        type="date"
        value={formData.sebcDate}
        onChange={handleChange}
        />

        <label>एस.ई.बी.सी प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव</label>
        <input name="sebcVillage" onChange={handleChange} value={formData.sebcVillage}/>

        <label>नॉन क्रीमीलेयर वैधता वर्ष</label>
        {/*<input name="sebcValidityYear" onChange={handleChange} value={formData.sebcValidityYear}/>*/}
        <input
        type="text"
        name="sebcValidityYear"
        value={formData.sebcValidityYear}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d{0,4}$/.test(value)) {
            handleChange(e);
          }
        }}
        inputMode="numeric"
      />
        </div>
      )}</>)}
        </div>
      )}

      {step === 4 && (
  <div className="form-section1">
    <h3>खालील माहिती तपासा:</h3>

    <div className="columns">
      <div className="column">
        <p>पूर्ण नाव : <strong> {formData.surname} {formData.firstname} {formData.fathername}</strong></p>
        <p>पत्ता : <strong>{formData.patta}</strong> </p>
        <p>जन्मतारीख : <strong>{formData.janmadin}</strong> </p>
        <p>मोबाईल : <strong>{formData.mobile}</strong> </p>
        <p>आधार क्रमांक : <strong>{formData.aadhar}</strong> </p>
        <p>ईमेल : <strong> {formData.email}</strong></p>
        <p>इयत्ता १० वी प्राप्त टक्केवारी : <strong> {formData.class10}</strong></p>
        <p>इयत्ता १२ वी प्राप्त टक्केवारी : <strong>{formData.class12}</strong> </p>
        <p>पदवी : <strong>{formData.ugDegree}</strong> </p>
        <p>पदवी प्राप्त श्रेणी : <strong>{formData.ugGrade}</strong> </p>
      </div>

      <div className="column">
        <p>एम.एस.सी.आय.टी टक्केवारी : <strong> {formData.mscit}</strong> </p>
        <p>जात प्रवर्ग : <strong> {formData.jati}</strong></p>
        {["अनुसूचित जाती (SC)", "अनुसूचित जमाती (ST)","विमुक्त जाती अ (NT- A)", "भटक्या जमाती ब (NT-B)","भटक्या जमाती क (NT-C)","भटक्या जमाती ड (NT-D)","इतर मागास वर्ग (OBC)"].includes(formData.jati) && (<><p>जात प्रमाणपत्र आहे का? :<strong> {formData.jatiPraman=== "true" ? "होय" : "नाही"}</strong> </p>
        {formData.jatiPraman === "true" && (<><p>जात प्रमाणपत्र क्रमांक : <strong>{formData.jatiCertNumber}</strong> </p>
        <p>जात प्रमाणपत्र दिनांक : <strong>{formData.jatiCertDate}</strong> </p>
        <p>जात प्रमाणपत्र गाव : <strong>{formData.jatiCertIssuer}</strong> </p></>)}
        <p>जात वैधता प्रमाणपत्र आहे का? : <strong> {formData.arakshan=== "true" ? "होय" : "नाही"}</strong></p>
        {formData.arakshan === "true" && ( <>
          <p>जात वैधता क्रमांक: <strong>{formData.arakshanCertNumber}</strong> </p>
          <p>जात वैधता प्रमाणपत्र दिनांक : <strong>{formData.arakshanCertDate}</strong></p>
          <p>जात प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव : <strong>{formData.arakshanCertIssuer}</strong></p>
          </>
          )}</>)}
          {["आर्थिक दुर्बल घटक ( EWS)"].includes(formData.jati) && (<>   <p>ई.डब्ल्यू.एस प्रमाणपत्र आहे का? : <strong>{formData.ews=== "true" ? "होय" : "नाही"}</strong> </p>
        {formData.ews === "true" && (<><p>इ.डब्ल्यू.एस प्रमाणपत्र दिनांक : <strong>{formData.ewsDate}</strong></p>
        <p>इ.डब्ल्यू.एस प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव : <strong>{formData.ewsVillage}</strong></p>
        <p>इ.डब्ल्यू.एस प्रमाणपत्र वैधता वर्ष : <strong>{formData.ewsValidityYear}</strong></p></>)}</>)}
        {formData.jati === "सामाजिक आणि शैक्षणिक मागास प्रवर्ग ( SEBC)" && (<> <p>एस.ई.बी.सी प्रमाणपत्र आहे का? : <strong>{formData.sebc=== "true" ? "होय" : "नाही"}</strong> </p>
        {formData.sebc === "true" && (<>
          <p>एस.ई.बी.सी प्रमाणपत्र दिनांक : <strong>{formData.sebcDate}</strong></p>
          <p>एस.ई.बी.सी प्रमाणपत्र देणाऱ्या प्रधिकाऱ्याचे गाव : <strong>{formData.sebcVillage}</strong></p>
          <p>नॉन क्रीमीलेयर वैधता वर्ष : <strong>{formData.sebcValidityYear}</strong></p>
        </>)}</>)}
      </div>
    </div>

    <h3>खालील गोष्टी तपासल्या आहेत:</h3>

    <div className="checkbox-row">
      <label>
        <input type="checkbox" name="fullName" checked={confirmChecks.fullName} onChange={handleConfirmChange} />
        नाव
      </label>

      <label>
        <input type="checkbox" name="dob" checked={confirmChecks.dob} onChange={handleConfirmChange} />
        जन्मतारीख
      </label>

      <label style={{ whiteSpace: 'nowrap' }}>
        <input type="checkbox" name="aadhar" checked={confirmChecks.aadhar} onChange={handleConfirmChange} />
        आधार क्रमांक
      </label>

      <label style={{ whiteSpace: 'nowrap' }}>
        <input type="checkbox" name="caste" checked={confirmChecks.caste} onChange={handleConfirmChange} />
        जात प्रवर्ग
      </label>
    </div>

    <div className="checkbox-errors">
      {errors.fullName && <span className="error">{errors.fullName}</span>}
      {errors.dob && <span className="error">{errors.dob}</span>}
      {errors.aadhar && <span className="error">{errors.aadhar}</span>}
      {errors.caste && <span className="error">{errors.caste}</span>}
    </div>

    <div className="final-confirmation">
        <label className="final-confirm-label">
          <input
            type="checkbox"
            name="finalConfirm"
            checked={confirmChecks.finalConfirm}
            onChange={handleConfirmChange}
          />
          मी दिलेली सर्व माहिती बरोबर आहे. एकदा फॉर्म सबमिट केल्यावर तुम्ही यामध्ये बदल करू शकणार नाही.
        </label>
        {errors.finalConfirm && <div className="error">{errors.finalConfirm}</div>}
      </div>
          </div>
        )} 
      <div className="form-buttons1">
      {step === 4 && <button
        type="submit"
        disabled={isSubmitting}
        style={{
          backgroundColor: isSubmitting ? "gray" : "green",
          cursor: isSubmitting ? "not-allowed" : "pointer",
          opacity: isSubmitting ? 0.6 : 1
        }}
      >
        सबमिट
      </button>}
      {step < 4 && <button type="button" onClick={handleNext}>पुढे</button>}
        {step > 1 && <button type="button" onClick={handleBack}>मागे</button>}
        
      </div>
    </form>
    </div>
    <Footer/>
    </>
  );
};

export default AssistanceForm;